import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { ActionButtons } from '../App';

// ── 무인상점 홈화면 템플릿 ────────────────────────────────────
// template: 'store' 테넌트에서 사용

export default function HomePageStore({ tenant_name, onNavigate, onLogout, authInfo, API_BASE, token, tabs }) {
  const [showProfile, setShowProfile] = useState(false);
  const [showPwForm,  setShowPwForm]  = useState(false);
  const [pwCurrent,   setPwCurrent]   = useState('');
  const [pwNew,       setPwNew]       = useState('');
  const [pwMsg,       setPwMsg]       = useState('');
  const [today,       setToday]       = useState(null);
  const [hourly,      setHourly]      = useState([]);
  const [recent,      setRecent]      = useState([]);
  const [loading,     setLoading]     = useState(true);

  const authHeaders = () => ({
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  });

  useEffect(() => {
    fetchAll();
    const timer = setInterval(fetchAll, 30000); // 30초마다 갱신
    return () => clearInterval(timer);
  }, []);

  const fetchAll = async () => {
    try {
      const todayRes = await fetch(`${API_BASE}/api/store/today`, { headers: authHeaders() });
      if (todayRes.ok) setToday(await todayRes.json());
      else setToday(DUMMY_TODAY);
    } catch { setToday(DUMMY_TODAY); }

    try {
      const hourlyRes = await fetch(`${API_BASE}/api/store/hourly`, { headers: authHeaders() });
      if (hourlyRes.ok) setHourly(await hourlyRes.json());
      else setHourly(DUMMY_HOURLY);
    } catch { setHourly(DUMMY_HOURLY); }

    try {
      const recentRes = await fetch(`${API_BASE}/api/store/recent?limit=10`, { headers: authHeaders() });
      if (recentRes.ok) setRecent(await recentRes.json());
      else setRecent(DUMMY_RECENT);
    } catch { setRecent(DUMMY_RECENT); }

    setLoading(false);
  };

  const fmtMoney = (v) => v ? Number(v).toLocaleString() + '원' : '0원';

  // 현재 시간 강조
  const currentHour = new Date().getHours();
  const chartData = hourly.filter(h => h.total > 0 || h.hour === currentHour); // 데이터 있는 시간대만

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa', fontFamily: '"Pretendard", sans-serif' }}>

      {/* 헤더 */}
      <div style={{ backgroundColor: '#0f172a', padding: '20px 20px 16px', boxShadow: '0 2px 8px rgba(0,0,0,0.2)' }}>
        <div style={{ maxWidth: '500px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ fontSize: '20px', fontWeight: '800', color: '#fff' }}>{tenant_name}</div>
            <div style={{ fontSize: '12px', color: '#94a3b8', marginTop: '2px' }}>🏪 무인상점 관리 시스템</div>
          </div>
          <div style={{ position: 'relative' }}>
            <div onClick={() => { setShowProfile(!showProfile); setShowPwForm(false); setPwMsg(''); }}
              style={{ width: '36px', height: '36px', borderRadius: '50%', backgroundColor: '#6366f1',
                       display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
              <span style={{ color: '#fff', fontSize: '14px', fontWeight: 'bold' }}>
                {(authInfo?.username || '?')[0].toUpperCase()}
              </span>
            </div>
            {showProfile && (
              <div style={{ position: 'absolute', right: 0, top: '44px', backgroundColor: '#fff',
                            borderRadius: '14px', boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                            padding: '12px', zIndex: 100, minWidth: '200px' }}>
                <div style={{ paddingBottom: '10px', borderBottom: '1px solid #f3f4f6', marginBottom: '8px' }}>
                  <div style={{ fontSize: '13px', fontWeight: 'bold', color: '#111827' }}>{authInfo?.username}</div>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '2px' }}>{tenant_name}</div>
                </div>
                <button onClick={() => { setShowPwForm(!showPwForm); setPwMsg(''); setPwCurrent(''); setPwNew(''); }}
                  style={{ width: '100%', padding: '7px 10px', background: 'none', border: 'none',
                           cursor: 'pointer', fontSize: '12px', color: '#6366f1', textAlign: 'left', borderRadius: '8px' }}>
                  🔑 비밀번호 변경
                </button>
                {showPwForm && (
                  <div style={{ marginTop: '6px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    <input type="password" placeholder="현재 비밀번호" value={pwCurrent}
                      onChange={e => setPwCurrent(e.target.value)}
                      style={{ padding: '8px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '12px', outline: 'none' }} />
                    <input type="password" placeholder="새 비밀번호" value={pwNew}
                      onChange={e => setPwNew(e.target.value)}
                      style={{ padding: '8px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '12px', outline: 'none' }} />
                    {pwMsg && <div style={{ fontSize: '11px', color: pwMsg.startsWith('✅') ? '#16a34a' : '#dc2626' }}>{pwMsg}</div>}
                    <button onClick={async () => {
                      if (!pwCurrent || !pwNew) { setPwMsg('❌ 모두 입력하세요'); return; }
                      try {
                        const res = await fetch(`${API_BASE}/api/auth/change-password`, {
                          method: 'POST', headers: authHeaders(),
                          body: JSON.stringify({ current_password: pwCurrent, new_password: pwNew }),
                        });
                        if (res.ok) { setPwMsg('✅ 변경 완료'); setPwCurrent(''); setPwNew(''); }
                        else { const d = await res.json(); setPwMsg('❌ ' + (d.detail || '변경 실패')); }
                      } catch { setPwMsg('❌ 서버 오류'); }
                    }}
                      style={{ padding: '8px', backgroundColor: '#6366f1', color: '#fff', border: 'none',
                               borderRadius: '8px', fontSize: '12px', cursor: 'pointer', fontWeight: 'bold' }}>
                      변경
                    </button>
                  </div>
                )}
                <div style={{ borderTop: '1px solid #f3f4f6', marginTop: '8px', paddingTop: '8px' }}>
                  <button onClick={onLogout}
                    style={{ width: '100%', padding: '7px 10px', background: 'none', border: 'none',
                             cursor: 'pointer', fontSize: '12px', color: '#ef4444', fontWeight: 'bold', textAlign: 'left', borderRadius: '8px' }}>
                    🚪 로그아웃
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div style={{ maxWidth: '500px', margin: '0 auto', padding: '16px' }}>

        {/* 오늘 매출 요약 카드 */}
        <div style={{ backgroundColor: '#0f172a', borderRadius: '20px', padding: '20px',
                      marginBottom: '16px', boxShadow: '0 4px 16px rgba(0,0,0,0.15)' }}>
          <div style={{ fontSize: '11px', color: '#94a3b8', marginBottom: '4px' }}>오늘 매출</div>
          <div style={{ fontSize: '32px', fontWeight: '900', color: '#fff', marginBottom: '16px' }}>
            {loading ? '---' : fmtMoney(today?.total)}
          </div>
          <div style={{ display: 'flex', gap: '0', borderTop: '1px solid #1e293b', paddingTop: '14px' }}>
            <div style={{ flex: 1, textAlign: 'center' }}>
              <div style={{ fontSize: '20px', fontWeight: '800', color: '#6366f1' }}>{today?.count || 0}</div>
              <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '2px' }}>결제건수</div>
            </div>
            <div style={{ flex: 1, textAlign: 'center', borderLeft: '1px solid #1e293b' }}>
              <div style={{ fontSize: '20px', fontWeight: '800', color: '#10b981' }}>{today?.visitors || 0}</div>
              <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '2px' }}>입장인원</div>
            </div>
            <div style={{ flex: 1, textAlign: 'center', borderLeft: '1px solid #1e293b' }}>
              <div style={{ fontSize: '20px', fontWeight: '800', color: '#f59e0b' }}>{fmtMoney(today?.avg)}</div>
              <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '2px' }}>인당평균</div>
            </div>
          </div>
        </div>

        {/* 시간대별 매출 차트 */}
        <div style={{ backgroundColor: '#fff', borderRadius: '16px', padding: '16px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.06)', marginBottom: '16px' }}>
          <div style={{ fontWeight: '700', fontSize: '14px', color: '#111827', marginBottom: '12px' }}>
            📊 시간대별 매출
          </div>
          <ResponsiveContainer width="100%" height={140}>
            <BarChart data={chartData} margin={{ top: 0, right: 0, left: -20, bottom: 0 }}>
              <XAxis dataKey="hour" tick={{ fontSize: 10 }} tickFormatter={h => `${h}시`} />
              <YAxis tick={{ fontSize: 10 }} tickFormatter={v => v >= 1000 ? `${v/1000}k` : v} />
              <Tooltip formatter={(v) => [fmtMoney(v), '매출']} labelFormatter={h => `${h}시`} />
              <Bar dataKey="total" radius={[4, 4, 0, 0]}>
                {chartData.map((entry, i) => (
                  <Cell key={i} fill={entry.hour === currentHour ? '#6366f1' : '#e0e7ff'} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* 최근 구매 내역 */}
        <div style={{ backgroundColor: '#fff', borderRadius: '16px', padding: '12px 16px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.06)', marginBottom: '16px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
            <div style={{ fontWeight: '700', fontSize: '13px', color: '#111827' }}>🧾 최근 구매</div>
            <button onClick={fetchAll}
              style={{ fontSize: '10px', color: '#6366f1', background: 'none', border: 'none', cursor: 'pointer' }}>
              새로고침
            </button>
          </div>
          {recent.length === 0 ? (
            <div style={{ textAlign: 'center', color: '#9ca3af', fontSize: '11px', padding: '8px' }}>구매 내역 없음</div>
          ) : (
            <div
              style={{ height: '80px', overflowY: 'auto', position: 'relative' }}
              onMouseEnter={e => e.currentTarget.querySelector('.scroll-store').style.animationPlayState = 'paused'}
              onMouseLeave={e => e.currentTarget.querySelector('.scroll-store').style.animationPlayState = 'running'}
              onTouchStart={e => e.currentTarget.querySelector('.scroll-store').style.animationPlayState = 'paused'}
              onTouchEnd={e => e.currentTarget.querySelector('.scroll-store').style.animationPlayState = 'running'}
            >
              <style>{`
                @keyframes scrollStore {
                  0% { transform: translateY(0); }
                  100% { transform: translateY(-50%); }
                }
              `}</style>
              <div className="scroll-store" style={{
                animation: `scrollStore ${recent.length * 2.5}s linear infinite`,
                display: 'flex', flexDirection: 'column', gap: '4px',
              }}>
                {[...recent, ...recent].map((sale, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '4px 0',
                                         borderBottom: '1px solid #f9fafb' }}>
                    <span style={{ fontSize: '10px' }}>🛒</span>
                    <span style={{ fontSize: '11px', fontWeight: '700', color: '#111827', flex: 1 }}>
                      {sale.items?.map(it => it.name).join(', ') || '구매'}
                    </span>
                    <span style={{ fontSize: '10px', color: '#9ca3af' }}>
                      {sale.member_id ? `회원${sale.member_id}` : '비회원'} · {sale.sold_at}
                    </span>
                    <span style={{ fontSize: '11px', fontWeight: '800', color: '#6366f1', minWidth: '50px', textAlign: 'right' }}>
                      {fmtMoney(sale.amount)}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* 공통 액션 버튼 */}
        <ActionButtons token={token} tabs={tabs} onNavigate={onNavigate} API_BASE={API_BASE} template='store' />

      </div>
    </div>
  );
}

// ── 더미 데이터 ───────────────────────────────────────────────
const DUMMY_TODAY = { total: 385000, count: 23, visitors: 31, avg: 16739 };

const DUMMY_HOURLY = [
  { hour: 0,  total: 0,      count: 0 },
  { hour: 1,  total: 0,      count: 0 },
  { hour: 2,  total: 0,      count: 0 },
  { hour: 3,  total: 0,      count: 0 },
  { hour: 4,  total: 0,      count: 0 },
  { hour: 5,  total: 0,      count: 0 },
  { hour: 6,  total: 0,      count: 0 },
  { hour: 7,  total: 0,      count: 0 },
  { hour: 8,  total: 0,      count: 0 },
  { hour: 9,  total: 9000,   count: 2 },
  { hour: 10, total: 22500,  count: 4 },
  { hour: 11, total: 31000,  count: 5 },
  { hour: 12, total: 45000,  count: 7 },
  { hour: 13, total: 38000,  count: 6 },
  { hour: 14, total: 27000,  count: 4 },
  { hour: 15, total: 41000,  count: 6 },
  { hour: 16, total: 53000,  count: 8 },
  { hour: 17, total: 62000,  count: 9 },
  { hour: 18, total: 48000,  count: 7 },
  { hour: 19, total: 35000,  count: 5 },
  { hour: 20, total: 28000,  count: 4 },
  { hour: 21, total: 18000,  count: 3 },
  { hour: 22, total: 0,      count: 0 },
  { hour: 23, total: 0,      count: 0 },
];

const DUMMY_RECENT = [
  { id: 1, amount: 18000, items: [{ name: '아이스크림', qty: 2 }, { name: '음료', qty: 1 }], member_id: 'M001', sold_at: '14:32' },
  { id: 2, amount: 9000,  items: [{ name: '과자', qty: 3 }], member_id: null, sold_at: '14:15' },
  { id: 3, amount: 25000, items: [{ name: '아이스크림', qty: 5 }], member_id: 'M023', sold_at: '13:58' },
  { id: 4, amount: 6000,  items: [{ name: '음료', qty: 2 }], member_id: 'M007', sold_at: '13:40' },
];
